import React, { useState } from 'react';
import { Button } from "../../components/tailwind/button";
import { Input } from "../../components/tailwind/input";
import { Tabs, TabsList, TabsTrigger } from "../../components/tailwind/tabs";
import { Download, Plus, Search, Filter } from "lucide-react";

import { OptInStats } from "../../components/whatsapp/optin/OptInStats";
import { OptInTable } from "../../components/whatsapp/optin/OptInTable";
import { AddOptInDialog } from "../../components/whatsapp/optin/AddOptInDialog";
import { usePageTitle } from "../../hooks/usePageTitle";

export default function OptInOut() {
    usePageTitle('Opt-in / Opt-out Management');
    const [activeTab, setActiveTab] = useState("all");
    const [addDialogOpen, setAddDialogOpen] = useState(false);
    const [searchQuery, setSearchQuery] = useState("");

    return (
    <div className="max-w-6xl mx-auto p-8 space-y-6">

            {/* Header Actions */}
            <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">

                <div className="flex items-center gap-3">
                    <Button variant="outline" className="gap-2 bg-white">
                        <Download className="h-4 w-4" />
                        Export CSV
                    </Button>
                    <Button
                        className="gap-2 bg-emerald-600 hover:bg-emerald-700 text-white"
                        onClick={() => setAddDialogOpen(true)}
                    >
                        <Plus className="h-4 w-4" />
                        Add Contact
                    </Button>
                </div>
            </div>

            {/* Stats Cards */}
            <OptInStats />

            {/* Filters and Search */}
            <div className="flex flex-col md:flex-row gap-4 justify-between items-center">
                <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full md:w-auto">
                    <TabsList className="bg-gray-100 p-1">
                        <TabsTrigger value="all" className="px-4">All Contacts</TabsTrigger>
                        <TabsTrigger value="opted_in" className="px-4">Opted In</TabsTrigger>
                        <TabsTrigger value="opted_out" className="px-4">Opted Out</TabsTrigger>
                    </TabsList>
                </Tabs>

                <div className="flex items-center gap-3 w-full md:w-auto">
                    <div className="relative flex-1 md:w-64">
                        <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-400" />
                        <Input
                            placeholder="Search name or phone..."
                            className="pl-9 bg-white"
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                        />
                    </div>
                    <Button variant="outline" size="icon" className="shrink-0 bg-white">
                        <Filter className="h-4 w-4 text-gray-500" />
                    </Button>
                </div>
            </div>

            {/* Contacts Table */}
            <OptInTable />

            {/* Add Contact Modal */}
            <AddOptInDialog
                open={addDialogOpen}
                onOpenChange={setAddDialogOpen}
            />
        </div>
    )
} 